import { Bell } from 'lucide-react'
import type { FC } from 'react'

import { EmptyResult } from '@/pages/_app/ui/empty-result'

import { type NotificationItem } from '@/lib/queries/notification/v1/history/types'

import { GeneralUpdateItem } from './general-update-item'

export interface GeneralUpdateListProps {
  notifications: NotificationItem[]
}

export const GeneralUpdateList: FC<GeneralUpdateListProps> = ({ notifications }) => {
  if (notifications.length === 0) {
    return (
      <EmptyResult icon={<Bell className="text-muted-foreground" size={40} />} text="No new updates at the moment." />
    )
  }

  return (
    <ul>
      {notifications.map((data, index) => (
        <li key={`${data.messageType}-${data.createdAt}-${data.message}-${index}`}>
          <GeneralUpdateItem data={data} />
        </li>
      ))}
    </ul>
  )
}
